export default "__VITE_ASSET__a10a1465__"